import React from 'react';
import { useModal } from '../../contexts/ModalContext';
import { BaseModal } from './BaseModal';

export function ModalContainer() {
  const { modal, closeModal } = useModal();

  if (!modal) {
    return null;
  }

  return (
    <BaseModal
      isOpen={modal.isOpen}
      onClose={closeModal}
      title={modal.title}
      size={modal.size}
      closeOnOutsideClick={modal.closeOnOutsideClick}
      showCloseButton={modal.showCloseButton}
    >
      {modal.content}
    </BaseModal>
  );
}